import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Triangle } from "lucide-react";

interface IRidgeCapProfile {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function RidgeCapProfile(props: IRidgeCapProfile) {
    const { value, onChange, loading } = { ...props };
    const [ridgeCap, setRidgeCap] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setRidgeCap(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setRidgeCap(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Ridge Cap Profile
            </Typography>

            <Select
                placeholder="Select ridge cap profile"
                value={ridgeCap}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Triangle size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Standard">Standard</Option>
                <Option value="Impact Resistant">Impact Resistant</Option>
                <Option value="High Profile">High Profile</Option>
            </Select>
        </Box>
    );
}
